
import { 
  Platform, 
  AppType, 
  Feature, 
  UserVolume, 
  Maintenance 
} from '@/hooks/useCostCalculator';

// Default pricing configuration
const defaultPricing = {
  platforms: { iOS: 10000, Android: 10000, Web: 8000, CrossPlatform: 15000 },
  appType: { MVP: 15000, Full: 30000, Enterprise: 50000 },
  features: {
    auth: 2000,
    logo: 1000,
    customUI: 3000,
    chat: 4000,
    payments: 5000,
    gps: 3000,
    backend: 8000,
    adminPanel: 4000,
    apiIntegration: 3000,
    push: 2000,
    offline: 3000,
    cloudSync: 3500
  },
  userVolume: {
    small: 0,
    medium: 5000,
    large: 15000,
    enterprise: 30000
  },
  maintenance: {
    '6': 3000,
    '12': 5000,
    '24': 9000
  }
};

interface PricingData {
  platforms: Record<Platform, number>;
  appType: Record<AppType, number>;
  features: Record<Feature, number>;
  userVolume: Record<UserVolume, number>;
  maintenance: Record<Maintenance, number>;
}

// This allows us to easily swap out the implementation later for REST API calls
class PricingService {
  private static instance: PricingService;
  private apiUrl: string = '/api/pricing'; // This would be the REST endpoint in the future
  
  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  public static getInstance(): PricingService {
    if (!PricingService.instance) {
      PricingService.instance = new PricingService();
    }
    return PricingService.instance;
  }

  // This method can be updated later to fetch from an API
  public async getPricingData(): Promise<PricingData> {
    // SIMULATION: In the future, this would be replaced with a real API call
    // return fetch(this.apiUrl).then(response => response.json());
    
    // For now, return the default pricing with a simulated delay
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(defaultPricing);
      }, 200); // Simulate a small network delay
    });
  }

  // Method to update the API URL if needed
  public setApiUrl(url: string): void {
    this.apiUrl = url;
  }
}

export default PricingService;
